import React, {useEffect, useState} from 'react';
import {Table, OverlayTrigger, Tooltip} from 'react-bootstrap';
import {truncateMiddleString} from '../../../../utils/stringUtils';

const DictationModelDataTable: React.FC<any> = ({
  dictationGroups,
  onDownloadAction,
}) => {
  const [openGroup, setOpenGroup] = useState<string | null>(null);

   useEffect(() => {
    if (dictationGroups?.length > 0) {
      setOpenGroup(dictationGroups[0].id);
    }
  }, [dictationGroups]);

  const toggleGroup = (id: string) => {
    setOpenGroup((prev) => (prev === id ? null : id));
  };

  return (
    <div className='border-0 mb-2 dictpopuop'>
      <Table responsive>
        <thead>
          <tr>
            <th style={{width: '10%', background: '#e0f7fa'}}>Sr.No</th>
            <th style={{width: '25%', background: '#e0f7fa'}}>Dictation ID</th>
            <th style={{width: '25%', background: '#e0f7fa'}}>File Name</th>
            <th style={{width: '20%', background: '#e0f7fa'}}>
              Dictation Duration
            </th>
            <th style={{width: '15%', background: '#e0f7fa'}}>Uploaded On</th>
            <th
              style={{
                width: '10%',
                background: '#e0f7fa',
                textAlign: 'center',
              }}
            >
              Action
            </th>
          </tr>
        </thead>

        <tbody>
          {dictationGroups.map((group: any) => (
            <React.Fragment key={group.id}>
              <tr
                style={{
                  background: '#e6f6fc',
                  cursor: 'pointer',
                }}
                onClick={() => toggleGroup(group.id)}
              >
                <td colSpan={6} style={{padding: '10px'}}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      fontWeight: '600',
                      color: '#0098d7',
                    }}
                  >
                    <span
                      className='material-symbols-outlined'
                      style={{marginRight: 8}}
                    >
                      {openGroup === group.id
                        ? 'do_not_disturb_on'
                        : 'add_circle'}
                    </span>

                    {group.title}

                    <span
                      className='border associated-location-count text-primary'
                      style={{fontSize: '14px', marginLeft: 8}}
                    >
                      {group.items.length}
                    </span>
                  </div>
                </td>
              </tr>

              {openGroup === group.id &&
                group.items?.map((file: any, idx: any) => (
                  <tr key={idx} style={{background: '#fff'}}>
                    <td>{file.srNo}</td>
                    <td>
                      <OverlayTrigger
                        placement='top'
                        overlay={<Tooltip>{file.dictationID}</Tooltip>}
                      >
                        <span>{truncateMiddleString(file.dictationID)}</span>
                      </OverlayTrigger>
                    </td>
                    <td>
                      <OverlayTrigger
                        placement='top'
                        overlay={<Tooltip>{file.fileName}</Tooltip>}
                      >
                        <span>{truncateMiddleString(file.fileName)}</span>
                      </OverlayTrigger>
                    </td>
                    <td>{file.recordingDuration}</td>
                    <td>{file.uploadDateTime}</td>
                    <td style={{textAlign: 'center'}}>
                      <span
                        className='material-icons color_brand'
                        style={{cursor: 'pointer'}}
                        onClick={() =>
                          onDownloadAction(file?.requestDictationAttachmentID, file.fileName)
                        }
                      >
                        download
                      </span>
                    </td>
                  </tr>
                ))}
            </React.Fragment>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default DictationModelDataTable;
